import React, { useState, useEffect, useRef, StrictMode } from 'react'
import './ConsoleNavMenu.css';
import * as signalR from "@microsoft/signalr";
import BatteryBox from './navMenu/BatteryBox';
import MsgBox from './navMenu/MsgBox';
import ModeBox from './navMenu/ModeBox';
import {useTranslation} from "react-i18next";
import { NavDropdown, Dropdown } from 'react-bootstrap';


function ConsoleNavMenu({drone, toggleShowMenu, toggleShowUserSettings, showMsgsAct, startMsgs, isAdmin, missionPlannerUrl, login}){
    //const { t } = useTranslation(['account']);//todo: ломает карту?
    const protocol = new signalR.JsonHubProtocol();
    const hubRef = useRef(null);
    const [imei, setImei] = useState(drone?.imei ?? null);
    const [arm, setArm] = useState(drone?.isArm);
    const [uavMode, setUavMode] = useState(drone?.mode);
    const [uavType, setUavType] = useState(drone?.mavType);
    const [hbUpdate, setHbUpdate] = useState(null);
    const [mName, setMName] = useState(drone?.name);
    const [isOnline, setIsOnline] = useState(drone?.isOnline ?? false);
    
    const [batteryRemaining, setBatteryRemaining] = useState(drone?.batteryRemaining);

    const [updateTelemFromHub, setUpdateTelemFromHub] = useState(null);
    const [telemetry, setTelemetry] = useState([]);
    const [currentTelemetry, setCurrentTelemetry] = useState({imei: 0, batteryRemaining: null, height: 0, speed: 0, sputniksCount: 0});

    useEffect(() => {
        console.log("ConsoleNavMenu mount");
        const connection = new signalR.HubConnectionBuilder()
            .withUrl("api/drone-hub")
            .withAutomaticReconnect([0, 2000, 10000, 10000, 30000, 10000])
            .withHubProtocol(protocol)
            .build();;

        connection.on('HbStatus', (message) =>
        {
            //console.log("hb navMenu");
            setHbUpdate(message);
        });

        connection.on('Telemetry', (message) => {
            setUpdateTelemFromHub(message);
        });

        connection.start();
        hubRef.current = connection;

        return () => {
            connection.stop();
            console.log("ConsoleNavMenu unmount!");
        };
      }, []);

    useEffect(() => {
        if(hbUpdate != null){
            if(hbUpdate.imei === drone?.imei) {
                setArm(hbUpdate.isArm);
                setUavMode(hbUpdate.mode);
                setUavType(hbUpdate.type);
            }
        } 
    }, [hbUpdate]);

    useEffect(() => {
        //console.log("update drone dd");
        if(drone != null) {
            setArm(drone.isArm);
            setUavMode(drone.mode);
            setImei(drone.imei);
            setBatteryRemaining(drone?.batteryRemaining);
            setUavType(drone?.mavType);
        }
        //console.log(drone);
        setIsOnline(drone?.isOnline ?? false);
        setMName(drone?.name);
        switchTelemetry();
        //todo: request api
    }, [drone]);

    useEffect(() => {
        setTelem(updateTelemFromHub);
    }, [updateTelemFromHub]);

    useEffect(() => {
        console.log("toggleShowMenu rerend!");
    }, [showMsgsAct, toggleShowMenu, toggleShowUserSettings]);

    function switchTelemetry() {
        if(drone === null) {
            return;
        }

        setCurrentTelemetry(telemetry.find((item) => item.imei === drone.imei));
    }

    function setTelem(msg) {
        setTelemetry((telems) => {
            const itemExists = telems.some((item) => item.imei === msg.imei);
            if(itemExists) {
                return telems.map((t) =>
                    t.imei === msg.imei
                      //? { ...t, batteryRemaining: msg.batteryRemaining, height: msg.height, speed: msg.speed, sputniksCount: msg.sputniksCount }
                      ? { ...t, ...msg }
                      : t
                  )
            } else {
                //return [...telems, {imei: msg.imei, batteryRemaining: msg.batteryRemaining, height: msg.height, speed: msg.speed, sputniksCount: msg.sputniksCount}];
                return [...telems, { ...msg }];
            }
        });

        if(msg?.imei === drone?.imei) {
            setCurrentTelemetry(msg);
        }
    }

    function EmptyGrid() {
        return(
            <div className='empty-grid'>
                <div className='tel-box logo-box'>Air-link Console</div>
                <div className='tel-box menu-box'>
                    <div className='menu-box-sep'/>
                    <NavDropdown
                        title={
                            <img className='menu-box-icon' src="/image/modem/user.svg"/>
                        }
                        id='collasible-nav-dropdown' menuVariant="dark">
                        <Dropdown.ItemText>{login}</Dropdown.ItemText>
                        {isAdmin ? 
                        <>
                            <NavDropdown.Item as="button" onClick={() => window.location.href = "/settings"}>Settings</NavDropdown.Item>
                            <NavDropdown.Item as="button" onClick={() => window.location.href = "/statistics"}>Statistics</NavDropdown.Item>
                            <NavDropdown.Item as="button" onClick={() => window.location.href = "/onlineDrones"} href='onlineDrones'>OnlineDrones</NavDropdown.Item>
                            <NavDropdown.Item as="button" onClick={() => window.location.href = "/users"} href='users'>Users</NavDropdown.Item>
                            <NavDropdown.Item as="button" onClick={() => window.location.href = "/firmware"} href='firmware'>Firmware</NavDropdown.Item>
                            <Dropdown.Divider />
                        </> : <></>}
                        <NavDropdown.Item as="button" onClick={() => {window.open(missionPlannerUrl, "_blank")}}>Скачать Mission Planner</NavDropdown.Item>
                        <Dropdown.Divider />
                        <NavDropdown.Item as="button" onClick={() => window.location.href = "api/user/logout"} href="">Выход</NavDropdown.Item>
                    </NavDropdown>
                </div>
            </div>
        )
    }


    return(
        <header>
            <StrictMode>
                <div className='console-nav-menu'>
                    { mName == null ? 
                    <div className='empty-grid'>
                        <div className='tel-box logo-box'>Air-link Console</div>
                        <div className='tel-box menu-box'>
                            <div className='menu-box-sep'/>
                            <NavDropdown
                                title={
                                    <img className='menu-box-icon' src="/image/modem/user.svg"/>
                                }
                                id='collasible-nav-dropdown' menuVariant="dark">
                                <Dropdown.ItemText>{login}</Dropdown.ItemText>
                                <Dropdown.Divider />
                                {isAdmin ? 
                                <>
                                    <NavDropdown.Item as="button" onClick={() => window.location.href = "/settings"}>Settings</NavDropdown.Item>
                                    <NavDropdown.Item as="button" onClick={() => window.location.href = "/statistics"}>Statistics</NavDropdown.Item>
                                    <NavDropdown.Item as="button" onClick={() => window.location.href = "/onlineDrones"} href='onlineDrones'>OnlineDrones</NavDropdown.Item>
                                    <NavDropdown.Item as="button" onClick={() => window.location.href = "/users"} href='users'>Users</NavDropdown.Item>
                                    <NavDropdown.Item as="button" onClick={() => window.location.href = "/firmware"} href='firmware'>Firmware</NavDropdown.Item>
                                    <Dropdown.Divider />
                                </> : <></>}
                                <NavDropdown.Item as="button" onClick={() => {window.open(missionPlannerUrl, "_blank")}}>Скачать Mission Planner</NavDropdown.Item>
                                <Dropdown.Divider />
                                <NavDropdown.Item as="button" onClick={() => window.location.href = "api/user/logout"} href="">Выход</NavDropdown.Item>
                            </NavDropdown>
                        </div>
                    </div>
                    
                    :  
                    <div className='telemetry-grid'>
                        <div className='tel-box name-box'>{mName}</div>
                        <div className='tel-box arm-box'>
                            {arm ? 'ARM' : 'DISARM'}
                        </div>
                        <MsgBox imei={imei} showMsgs={showMsgsAct} startMsgs={startMsgs}/>
                        <ModeBox type={uavType} mode={uavMode} isOnline={isOnline}/>
                        <div className='tel-box sat-box'><img className='sat-box-icon' src="/image/modem/sat.svg"/><div>{currentTelemetry?.sputniksCount ?? -1}</div></div>
                        <BatteryBox batterys={currentTelemetry?.batteryRemaining}/>
                        <div className='tel-box menu-box' >
                            <img className='menu-box-sep' onClick={toggleShowMenu} src="/image/modem/settings.svg"/>
                            {/*<img className='menu-box-icon'onClick={toggleShowUserSettings} src="/image/modem/user.svg"/>*/}
                            <NavDropdown
                                title={
                                    <img className='menu-box-icon' src="/image/modem/user.svg"/>
                                }
                                id='collasible-nav-dropdown' menuVariant="dark">
                                <Dropdown.ItemText>{login}</Dropdown.ItemText>
                                <Dropdown.Divider />
                                {isAdmin ? 
                                <>
                                    <NavDropdown.Item as="button" onClick={() => window.location.href = "/settings"}>Settings</NavDropdown.Item>
                                    <NavDropdown.Item as="button" onClick={() => window.location.href = "/statistics"}>Statistics</NavDropdown.Item>
                                    <NavDropdown.Item as="button" onClick={() => window.location.href = "/onlineDrones"} href='onlineDrones'>OnlineDrones</NavDropdown.Item>
                                    <NavDropdown.Item as="button" onClick={() => window.location.href = "/users"} href='users'>Users</NavDropdown.Item>
                                    <NavDropdown.Item as="button" onClick={() => window.location.href = "/firmware"} href='firmware'>Firmware</NavDropdown.Item>
                                    <Dropdown.Divider />
                                </> : <></>}
                                <NavDropdown.Item as="button" onClick={() => {window.open(missionPlannerUrl, "_blank")}}>Скачать Mission Planner</NavDropdown.Item>
                                <Dropdown.Divider />
                                <NavDropdown.Item as="button" onClick={() => window.location.href = "api/user/logout"} href="">Выход</NavDropdown.Item>
                            </NavDropdown>
                        </div>
                    </div>}
                </div>
            </StrictMode>
        </header>
    )
}

export default ConsoleNavMenu;